import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator } from '@angular/material';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { ConfiguracionWebService } from 'src/app/services/configuracionWeb.service';
import { RutaService } from '../../../../services/operaciones/ruta.service';
import * as moment from 'moment/moment';


@Component({
  selector: 'dialog-log',
  templateUrl: '../dialog-log/dialog-log.component.html',
  styleUrls: ['../dialog-log/dialog-log.component.scss'],
  providers: [  ]
})
  
export class DialogLog implements OnInit {
    
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;

  public displayedColumns = ['folio','programa','pedidoZAM','accion','usuario','detalle','fecha_movimiento','fecha_inicio_carga','fecha_inicio_descarga','remitente','destinatario','origen','destino','idRutaZam','vehiculo','operador','remolque1','remolque2'];
  usuarioSession
  idRazonSocial
  url
  fechaInicio: string;
  fechaFin: string;
  
  locale: {
    format: 'DD/MM/YYYY',
    separator: ' - ',
    cancelLabel: 'Cancelar',
    applyLabel: 'Aplicar',
    firstDay: 1 // first day is monday
  };
  
  ranges: any = {
    'Hoy': [moment(), moment()],
    'Semana actual': [moment().startOf('week'), moment().endOf('week')],
    'Mes actual': [moment().startOf('month'), moment().endOf('month')]
  };

  dateRange: any = {
    startDate: moment().startOf('week'),
    endDate: moment().endOf('week')
  };

  constructor(
    public dialogRef: MatDialogRef<DialogLog>,
    private rutaService: RutaService,
    @Inject(MAT_DIALOG_DATA) public data:any    
  ) { 
    
  }
  
  ngOnInit(): void {    
    this.usuarioSession = JSON.parse(sessionStorage.getItem("usuario"));
    this.idRazonSocial = this.usuarioSession.idRazonSocial;
    this.dateRange.startDate = moment(this.data.fechaInicio)
    this.dateRange.endDate = moment(this.data.fechaFin)
    this.fechaInicio = this.dateRange.startDate.format("YYYY-MM-DD 00:00:00");
    this.fechaFin = this.dateRange.endDate.format("YYYY-MM-DD 23:59:59");    
    if(!this.data.isLogGeneral){      
      this.displayedColumns = [
        'idPlanner',
        'Unidad',
        'fecha',
        'viajeZAM',
        'operadorZAM',
        'estatus',
        'mensajeZAM' 
      ];
    }
    this.getLog();
  }  

  getLog(){
    this.rutaService.consultarLogATQ(this.fechaInicio,this.fechaFin,this.idRazonSocial,this.data.isLogGeneral)
    .subscribe(data => {
      this.dataSource.data = data;
      this.dataSource.paginator = this.paginator;
    }), error => console.error(error);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    // this.filtro = filterValue.trim().toLowerCase();
  }

  fechaSeleccionada() {
    this.fechaInicio = this.dateRange.startDate.format("YYYY-MM-DD 00:00:00");
    this.fechaFin = this.dateRange.endDate.format("YYYY-MM-DD 23:59:59");    
    this.getLog();
  }
    
}